import { EMPTY_OBJECT } from 'constants/globalConstants';
import { get } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetSharedData as resetAction,
  setSharedData as action,
} from 'store/app/actions';

interface SharedDataParams {
  id: string;
  dataType?: any;
  consumer?: boolean;
  data?: any;
  shouldResetOnUnmount?: boolean;
  lazy?: boolean;
}

interface SharedDataType {
  data: any;
  set: (data: any) => void;
}

const useSharedData = ({
  id,
  dataType = EMPTY_OBJECT,
  consumer = true,
  data: initialData,
  shouldResetOnUnmount = true,
  lazy = true,
}: SharedDataParams): SharedDataType => {
  const dispatch = useDispatch();
  const data = useSelector((state: any) =>
    consumer ? get(state.getIn(['app', 'sharedData']), id, dataType) : dataType,
  );

  const set = useCallback((_data) => dispatch(action(id, _data)), []);

  useEffect(() => {
    if (!lazy) dispatch(action(id, initialData));
    return () => {
      if (shouldResetOnUnmount) dispatch(resetAction(id));
    };
  }, []);

  return { set, data };
};

export default useSharedData;
